import React from "react";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

export const EditorColumnFormatter = (cellContent, row) => <div>{ReactHtmlParser(row.body)}</div>;
